export default {"src":"/fly/_next/static/media/close_circle_icon.23e30dc3.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};